import type { IconData } from '@stacksjs/iconify-core'

export const colorBorder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M143.4 331.909a17.5 17.5 0 0 0 3.285-.311l89.867-21.281l190.2-190.2a62.922 62.922 0 1 0-88.986-88.985l-190.2 190.2l-21.134 89.185l-.145.674a17.435 17.435 0 0 0 17.113 20.718m33.21-94.369L360.4 53.755a30.922 30.922 0 1 1 43.731 43.731L220.342 281.272l-57.314 13.582ZM472 376H40a24.03 24.03 0 0 0-24 24v72a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24v-72a24.03 24.03 0 0 0-24-24m-8 88H48v-56h416Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default colorBorder
